module.exports = __webpack_public_path__ + "static/media/downloadCenter.b26a247d.svg";